import React from "react";
import Input from "..";

export default function NameInput(props) {
  const { firstName, setFirstName, lastName, setLastName, error } = props;

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleEnter = () => {};
  return (
    <div className="name-input">
      <label className="label">What’s your Name?</label>
      <div className="name-input__container">
        <Input
          value={firstName}
          onChange={handleFirstNameChange}
          error={error}
          showLabel={false}
          showErrorMessage={false}
          placeholder="First Name"
        />
        <Input
          value={lastName}
          onChange={handleLastNameChange}
          onEnter={handleEnter}
          showLabel={false}
          showErrorMessage={false}
          placeholder="Last Name"
        />
      </div>
      {error?.length > 0 ? <div className="error-message">{error}</div> : null}
    </div>
  );
}
